var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-text',[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('apexchart',{attrs:{"type":"donut","height":"350","options":_vm.chartOptions,"series":_vm.seriesData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }